import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import xor from 'lodash/xor';
import { saveSessionStorageState, sortListWithIds } from 'utils';
import { TTopCategory } from 'data';
import { CatalogueContentState } from './types';
import { sliceKey as name } from './utils';

const sessionStorageItemKey = `${name}_selectedFilterItems`;

export const initialState: CatalogueContentState = {
	selectedFilterItems: [],
	isModalOpen: false,
};

const CatalogueContentSlice = createSlice({
	name,
	initialState,
	reducers: {
		changeSelectedFilterItems(
			state,
			action: PayloadAction<{ changedFilterItems: number[]; topCategories: TTopCategory[] }>
		) {
			const { changedFilterItems, topCategories } = action.payload;
			state.selectedFilterItems = sortListWithIds(
				xor(state.selectedFilterItems, changedFilterItems),
				topCategories
			);
			saveSessionStorageState(sessionStorageItemKey, state.selectedFilterItems);
		},
		setSelectedFilterItems(state, action: PayloadAction<{ selectedFilterItems: number[] }>) {
			const { selectedFilterItems } = action.payload;
			state.selectedFilterItems = selectedFilterItems;
			if (!__IS_SERVER__) {
				saveSessionStorageState(sessionStorageItemKey, state.selectedFilterItems);
			}
		},
		resetSelectedFilterItems(state) {
			state.selectedFilterItems = [];
			saveSessionStorageState(sessionStorageItemKey, state.selectedFilterItems);
		},
		openModal(state) {
			state.isModalOpen = true;
		},
		closeModal(state) {
			state.isModalOpen = false;
		},
	},
});

export const { actions, reducer, name: sliceKey } = CatalogueContentSlice;
